import { useParams } from 'react-router-dom';

import { OrganisationRunsTable } from './OrganisationRunsTable';
import { useFetchOrgActiveRuns } from '../../../api/queries/analyticsQueries/useFetchOrgRuns';
import useGetOrganisation from '../../../api/queries/useGetOrganisation';
import PageWrapper from '../../../components/molecules/PageWrappers/PageWrapper';

export const OrganisationRuns = () => {
  const { orgId } = useParams<{ orgId: string }>();

  const { data: organisation } = useGetOrganisation(orgId ?? '');
  const { data: runsData, isFetching: isFetchingRuns } = useFetchOrgActiveRuns(orgId ?? '');

  return (
    <PageWrapper className="bg-gray-50">
      <div className="flex w-full flex-col items-start justify-start px-4 md:px-6 lg:px-8">
        <div className="mb-8 flex w-full flex-col gap-6">
          <div className="w-full rounded-xl bg-white p-6 shadow-sm">
            <div className="flex flex-col gap-6">
              <div className="flex flex-col">
                <h1 className="text-xl font-semibold text-gray-800">{organisation?.name} Runs</h1>
                <p className="text-sm text-gray-600">
                  Manage and view active / queued runs for this organisation. Note completed and failed runs are not
                  shown.
                </p>
              </div>
            </div>
          </div>

          <OrganisationRunsTable runs={runsData ?? []} isLoading={isFetchingRuns} />
        </div>
      </div>
    </PageWrapper>
  );
};
